import { application } from "./application"

import SidebarController from "./sidebar_controller"
import DropdownController from "./dropdown_controller"
import TopbarController from "./topbar_controller"
import ToastController from "./toast_controller"
import SearchController from "./search_controller"
import ModalController from "./modal_controller"
import KanbanController from "./kanban_controller"
import FilterController from "./filter_controller"
import NotificationsController from "./notifications_controller"
import BulkActionController from "./bulk_action_controller"
import BulkActionsController from "./bulk_actions_controller"
import ColumnResizeController from "./column_resize_controller"
import SidebarSectionController from "./sidebar_section_controller"
import ToggleController from "./toggle_controller"
import BatchSelectController from "./batch_select_controller"
import InlineEditController from "./inline_edit_controller"
import InlineSelectController from "./inline_select_controller"
import InlineToggleController from "./inline_toggle_controller"
import InlineComboboxController from "./inline_combobox_controller"
import TaskableSearchController from "./taskable_search_controller"
import DashboardFiltersController from "./dashboard_filters_controller"
import TaskCompleteController from "./task_complete_controller"
import ActivityFilterController from "./activity_filter_controller"
import AccountSearchController from "./account_search_controller"
import AccountComboboxController from "./account_combobox_controller"
import RowLinkController from "./row_link_controller"
import CampaignPreviewController from "./campaign_preview_controller"
import LoadMoreController from "./load_more_controller"
import SearchFilterController from "./search_filter_controller"
import SessionsModalController from "./sessions_modal_controller"
import AccountAttachController from "./account_attach_controller"
import AlertesController from "./alertes_controller"
import EmailComposeController from "./email_compose_controller"
import CcRecipientsController from "./cc_recipients_controller"
import BulkSelectController from "./bulk_select_controller"
import SupportEditController from "./support_edit_controller"
import ReferralEditController from "./referral_edit_controller"
import ReferralCleanController from "./referral_clean_controller"
import MentionController from "./mention_controller"
import DealKanbanController from "./deal_kanban_controller"
import DealB2cFormController from "./deal_b2c_form_controller"
import DealB2cDendreoFilterController from "./deal_b2c_dendreo_filter_controller"
import StageDropdownController from "./stage_dropdown_controller"
import ClickToCallController from "./click_to_call_controller"
import CalendarEventPickerController from "./calendar_event_picker_controller"
import FollowupEmailController from "./followup_email_controller"
import MergeConfirmController from "./merge_confirm_controller"
import ChatController from "./chat_controller"
import LeadGenController from "./lead_gen_controller"
import DetailsPersistController from "./details_persist_controller"
import DetailsHashController from "./details_hash_controller"
import StaticModalController from "./static_modal_controller"
import SlideoverController from "./slideover_controller"
import CallModalController from "./call_modal_controller"
import PhoningController from "./phoning_controller"
import SiretCheckController from "./siret_check_controller"
import ActivityFormController from "./activity_form_controller"
import ComboboxController from "./combobox_controller"
import ListContactPickerController from "./list_contact_picker_controller"
import ClearableInputController from "./clearable_input_controller"
import DealFormController from "./deal_form_controller"
import MarketingListController from "./marketing_list_controller"
import MembershipExclusionController from "./membership_exclusion_controller"
import TableStickyController from "./table_sticky_controller"
import PasswordVisibilityController from "./password_visibility_controller"
import ShowMoreController from "./show_more_controller"
import PhoningTimerController from "./phoning_timer_controller"
import PhoningScriptController from "./phoning_script_controller"
import ContactFormController from "./contact_form_controller"
import LoadingButtonController from "./loading_button_controller"
import IaActionController from "./ia_action_controller"
import AsyncStatusController from "./async_status_controller"
import PollRefreshController from "./poll_refresh_controller"
import SessionTypeFilterController from "./session_type_filter_controller"
import CheckboxDropdownController from "./checkbox_dropdown_controller"
import ImportTemplateController from "./import_template_controller"
import ImportDropzoneController from "./import_dropzone_controller"
import LocalFilterController from "./local_filter_controller"
import PlaybookController from "./playbook_controller"
import CampaignAddContactController from "./campaign_add_contact_controller"
import OwnerReassignController from "./owner_reassign_controller"
import MeetingFormController from "./meeting_form_controller"
import ObjectiveFormController from "./objective_form_controller"
import CountUpController from "./count_up_controller"
import DailyFocusController from "./daily_focus_controller"
import CommandPaletteController from "./command_palette_controller"
import HeroSliderController from "./hero_slider_controller"
import EntityTabsController from "./entity_tabs_controller"
import FiltersPanelController from "./filters_panel_controller"
import SettingsFilterController from "./settings_filter_controller"
import EntityPickerController from "./entity_picker_controller"
import CategoryChipsController from "./category_chips_controller"
import KpiModalCloseController from "./kpi_modal_close_controller"
import CardExpandController from "./card_expand_controller"
// import DevisFormController from "./devis_form_controller" // conservé pour usage futur (générateur devis PDF)

application.register("sidebar", SidebarController)
application.register("dropdown", DropdownController)
application.register("topbar", TopbarController)
application.register("toast", ToastController)
application.register("search", SearchController)
application.register("modal", ModalController)
application.register("kanban", KanbanController)
application.register("filter", FilterController)
application.register("notifications", NotificationsController)
application.register("bulk-action", BulkActionController)
application.register("bulk-actions", BulkActionsController)
application.register("column-resize", ColumnResizeController)
application.register("sidebar-section", SidebarSectionController)
application.register("toggle", ToggleController)
application.register("batch-select", BatchSelectController)
application.register("inline-edit", InlineEditController)
application.register("inline-select", InlineSelectController)
application.register("inline-toggle", InlineToggleController)
application.register("inline-combobox", InlineComboboxController)
application.register("taskable-search", TaskableSearchController)
application.register("dashboard-filters", DashboardFiltersController)
application.register("task-complete", TaskCompleteController)
application.register("activity-filter", ActivityFilterController)
application.register("account-search", AccountSearchController)
application.register("account-combobox", AccountComboboxController)
application.register("row-link", RowLinkController)
application.register("campaign-preview", CampaignPreviewController)
application.register("load-more", LoadMoreController)
application.register("search-filter", SearchFilterController)
application.register("sessions-modal", SessionsModalController)
application.register("account-attach", AccountAttachController)
application.register("alertes", AlertesController)
application.register("email-compose", EmailComposeController)
application.register("cc-recipients", CcRecipientsController)
application.register("bulk-select", BulkSelectController)
application.register("support-edit", SupportEditController)
application.register("referral-edit", ReferralEditController)
application.register("referral-clean", ReferralCleanController)
application.register("mention", MentionController)
application.register("deal-kanban", DealKanbanController)
application.register("deal-b2c-form", DealB2cFormController)
application.register("deal-b2c-dendreo-filter", DealB2cDendreoFilterController)
application.register("stage-dropdown", StageDropdownController)
application.register("click-to-call", ClickToCallController)
application.register("calendar-event-picker", CalendarEventPickerController)
application.register("followup-email", FollowupEmailController)
application.register("merge-confirm", MergeConfirmController)
application.register("chat", ChatController)
application.register("lead-gen", LeadGenController)
application.register("details-persist", DetailsPersistController)
application.register("details-hash", DetailsHashController)
application.register("static-modal", StaticModalController)
application.register("slideover", SlideoverController)
application.register("phoning", PhoningController)
application.register("siret-check", SiretCheckController)
application.register("activity-form", ActivityFormController)
application.register("combobox", ComboboxController)
application.register("list-contact-picker", ListContactPickerController)
application.register("clearable-input", ClearableInputController)
application.register("deal-form", DealFormController)
application.register("marketing-list", MarketingListController)
application.register("membership-exclusion", MembershipExclusionController)
application.register("table-sticky", TableStickyController)
application.register("password-visibility", PasswordVisibilityController)
application.register("show-more", ShowMoreController)
application.register("phoning-timer", PhoningTimerController)
application.register("phoning-script", PhoningScriptController)
application.register("contact-form", ContactFormController)
application.register("loading-button", LoadingButtonController)
application.register("ia-action", IaActionController)
application.register("async-status", AsyncStatusController)
application.register("poll-refresh", PollRefreshController)
application.register("session-type-filter", SessionTypeFilterController)
application.register("checkbox-dropdown", CheckboxDropdownController)
application.register("import-template", ImportTemplateController)
application.register("import-dropzone", ImportDropzoneController)
application.register("local-filter", LocalFilterController)
application.register("playbook", PlaybookController)
application.register("campaign-add-contact", CampaignAddContactController)
application.register("owner-reassign", OwnerReassignController)
application.register("meeting-form", MeetingFormController)
application.register("objective-form", ObjectiveFormController)
application.register("count-up", CountUpController)
application.register("daily-focus", DailyFocusController)
application.register("command-palette", CommandPaletteController)
application.register("hero-slider", HeroSliderController)
application.register("call-modal", CallModalController)
application.register("entity-tabs", EntityTabsController)
application.register("filters-panel", FiltersPanelController)
application.register("settings-filter", SettingsFilterController)
application.register("entity-picker", EntityPickerController)
application.register("category-chips", CategoryChipsController)
application.register("kpi-modal-close", KpiModalCloseController)
application.register("card-expand", CardExpandController)
// application.register("devis-form", DevisFormController)

// Sprint 2 (01/06/2026) — Autofill end_date sur form DealB2c
import AutofillEndDateController from "./autofill_end_date_controller"
application.register("autofill-end-date", AutofillEndDateController)
